"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var adhere_ui_conditionalrender_1 = __importDefault(require("@baifendian/adhere-ui-conditionalrender"));
var adhere_ui_historyback_1 = __importDefault(require("@baifendian/adhere-ui-historyback"));
var adhere_util_intl_1 = __importDefault(require("@baifendian/adhere-util-intl"));
var ToolBarLayout_1 = __importDefault(require("./ToolBarLayout"));
/**
 * BackLayout
 * @class BackLayout
 * @classdesc BackLayout
 */
var BackLayout = (0, react_1.memo)(function (props) {
  var _a = props.topToolBarItems,
    topToolBarItems = _a === void 0 ? [] : _a,
    _b = props.isShowBack,
    isShowBack = _b === void 0 ? true : _b,
    _c = props.backPath,
    backPath = _c === void 0 ? '/' : _c,
    _d = props.enforceBackPath,
    enforceBackPath = _d === void 0 ? '' : _d,
    history = props.history,
    backTitle = props.backTitle,
    children = props.children,
    resetProps = __rest(props, ["topToolBarItems", "isShowBack", "backPath", "enforceBackPath", "history", "backTitle", "children"]);
  var toolbar = (0, react_1.useMemo)(function () {
    return __spreadArray(__spreadArray([], topToolBarItems || [], true), [react_1.default.createElement(adhere_ui_conditionalrender_1.default, {
      key: "backBtn",
      conditional: isShowBack
    }, function () {
      return react_1.default.createElement(antd_1.Button, {
        onClick: function () {
          if (enforceBackPath) {
            history.replace(enforceBackPath);
          } else {
            (0, adhere_ui_historyback_1.default)(history, backPath);
          }
        }
      }, backTitle || adhere_util_intl_1.default.v('返回'));
    })], false).filter(function (t) {
      if ('props' in t && 'conditional' in t.props) return t.props.conditional;
      return true;
    });
  }, [topToolBarItems, isShowBack, enforceBackPath, backPath, backTitle]);
  return react_1.default.createElement(ToolBarLayout_1.default, __assign({}, resetProps, {
    topToolBarItems: toolbar
  }), children);
});
BackLayout.displayName = 'BackLayout';
exports.default = BackLayout;